var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.89 13.2794C18.537 14.6224 16.867 15.5714 13.526 17.4694C10.296 19.3044 8.681 20.2214 7.38 19.8534C6.84076 19.7006 6.35021 19.4109 5.956 19.0124C5 18.0474 5 16.1764 5 12.4334C5 8.69045 5 6.81945 5.956 5.85445C6.35032 5.45638 6.84086 5.16701 7.38 5.01445C8.681 4.64445 10.296 5.56245 13.526 7.39745C16.866 9.29545 18.537 10.2444 18.891 11.5874C19.038 12.1419 19.038 12.725 18.891 13.2794",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.016b8aa4b818d7d98eb837debe15f164.svg";
export { ForwardRef as ReactComponent };